// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\CommonService.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { SelectOption } from './SelectOption';
import { get, post, put, del } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
import { RequestResult } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/RequestResult';
import { Condition } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Condition';
/**
 * 选项 通用服务类
 * 选项，当设置项为单选或多选的时候有效
 */
export class SelectOptionService {
  /**
   * 实体 选项 的通用CRUD服务
   * @selectOption 要创建的实体：选项
   * @return 返回：创建的实体
   */
  static async CreateAsync(selectOption: SelectOption): Promise<SelectOption | null> {
    return new Promise((resolve, reject) => {
      post('metapattern-ide-mda/api/selectoption/create', selectOption.toJson())
        .then((response: any) => {
          if (response) {
            const result = SelectOption.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务：根据ID加载实体
   * @param id 要查询的实体id
   * @return 返回：实体DTO
   */
  static async LoadByIdAsync(id: string): Promise<SelectOption | null> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/selectoption/loadbyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = SelectOption.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务：根据ID加载实体
   * @param ids 要查询的实体id列表
   * @return 返回：实体DTO列表
   */
  static async LoadByIdsAsync(ids: Array<string>): Promise<Array<SelectOption>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/selectoption/loadbyids', { ids: ids.join(',') })
        .then((response: any) => {
          const result = new Array<SelectOption>();
          if (response) {
            response.forEach((item: SelectOption) => {
              result.push(SelectOption.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务：获取所有有效的实体
   * @return 返回：实体DTO列表
   */
  static async LoadAllAsync(): Promise<Array<SelectOption>> {
    return new Promise((resolve, reject) => {
      get('metapattern-ide-mda/api/selectoption/loadall')
        .then((response: any) => {
          const result = new Array<SelectOption>();
          if (response) {
            response.forEach((item: SelectOption) => {
              result.push(SelectOption.Create(item));
            });
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务：更新实体
   * @selectOption 要更新的实体：选项
   * @return 返回：更新后的实体
   */
  static async UpdateAsync(selectOption: SelectOption): Promise<SelectOption | null> {
    return new Promise((resolve, reject) => {
      put('metapattern-ide-mda/api/selectoption/update', selectOption.toJson())
        .then((response: any) => {
          if (response) {
            const result = SelectOption.Create(response);
            resolve(result);
          } else {
            resolve(null);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务 ：根据id逻辑删除实体
   * @param id 要删除的实体id
   * @return 返回：是否成功执行
   */
  static async DeleteAsync(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mda/api/selectoption/deletebyid', { id: id })
        .then((response: any) => {
          if (response) {
            const result = response as boolean;
            resolve(result);
          } else {
            resolve(false);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  /**
   * 实体 选项 的通用CRUD服务 ：根据id列表逻辑删除实体
   * @param ids 要删除的实体id列表
   * @return 返回：成功删除的条数
   */
  static async DeleteBatchAsync(ids: Array<string>): Promise<number> {
    return new Promise((resolve, reject) => {
      del('metapattern-ide-mda/api/selectoption/deletebyids', { ids: ids.join(',') })
        .then((response: any) => {
          if (response) {
            const result = response as number;
            resolve(result);
          } else {
            resolve(0);
          }
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
